type Env = "production" | "staging" | "development";

const selector = useRuntimeConfig().public.ENV || process.env.NODE_ENV;

const serverUrls = (): Record<Env, Record<string, string>> => ({
  development: {
    host: "https://dev.sanjab.co:3000",
    sanjabAuth: "https://accounts-staging.sanjab.co",
    accounts: "https://accounts-staging.yektanet.com",
    baseDomain: "https://staging.sanjab.co",
    baseUrl: "https://staging.sanjab.co/api",
  },
  staging: {
    host: "https://app-staging.sanjab.co",
    sanjabAuth: "https://accounts-staging.sanjab.co",
    accounts: "https://accounts-staging.yektanet.com",
    baseDomain: "https://staging.sanjab.co",
    baseUrl: "https://staging.sanjab.co/api",
  },
  production: {
    host: "https://app.sanjab.co",
    sanjabAuth: "https://accounts.sanjab.co",
    accounts: "https://accounts.yektanet.com",
    baseDomain: "https://api.sanjab.co",
    baseUrl: "https://api.sanjab.co/api",
  },
});

export default serverUrls()[selector as Env];
